import {Box, useMediaQuery, useTheme} from '@mui/material';
import React from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import AppNavBar from '../containers/AppNavBar';
import PageViewTracker from '../lib/PageViewTracker';
import {navigation} from '../theme/tokens';
import BottomNav from './layout/BottomNav';
import ScrollToTop from './utils/ScrollToTop';

// Routes that should show the bottom navigation on mobile
const BOTTOM_NAV_ROUTES = ['/app', '/map', '/help'];

export default function AppContainer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {pathname} = useLocation();

  // Show bottom nav on mobile for specific routes
  const showBottomNav =
    isMobile && BOTTOM_NAV_ROUTES.some((route) => pathname.startsWith(route));

  return (
    <React.Fragment>
      <ScrollToTop />
      <PageViewTracker />
      <AppNavBar />
      <Box
        component="main"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          pt: {xs: '56px', md: '64px'}, // Account for fixed AppBar height (56px mobile, 64px desktop)
          pb: showBottomNav ? `${navigation.bottomNavHeight}px` : 0, // Account for bottom nav
        }}>
        <Outlet />
      </Box>
      {showBottomNav && <BottomNav />}
    </React.Fragment>
  );
}
